<template>
	<vs-row vs-w="12">
		<vs-col vs-lg="12" vs-sm="12" vs-xs="12">
			<form>
				<div class="vx-row mb-6">
					<div class="vx-col w-full">
						<vs-input
							name="name"
							class="w-full"
							icon-pack="feather"
							icon="icon-briefcase"
							icon-no-border
							:label-placeholder="$t('BreakTable.Name')"
							v-model="breakItem.name"
							v-validate="'required'"
						/>
						<span class="text-danger text-sm" v-show="errors.has('name')">{{
							$t("Status.Form.ValidMessages.Name")
						}}</span>
					</div>
				</div>

				<div class="vx-row">
					<div class="vx-col w-full">
						<div class="float-right">
							<vs-button class="mr-3 mb-2" @click="submitForm">{{
								isEditActive ? SubmitButtonTitleEdit : SubmitButtonTitleCreate
							}}</vs-button>
							<vs-button color="danger" @click="cancel">{{ $t("MODULE_PERMISSION.Cancel") }}</vs-button>
						</div>
					</div>
				</div>
			</form>
		</vs-col>
	</vs-row>
</template>
<script>
import DateUtils from "@/helpers/DateUtils.js";
import moduleStatus from "@/store/status/moduleStatus.js";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import {Validator} from "vee-validate";
import vSelect from "vue-select";

const dictStatus = {
	custom: {
		name: {
			required: "Please enter your Status name here",
		},
	},
};

// register custom messages
Validator.localize("en", dictStatus);

export default {
	name: "BreakForm",
	props: {
		isEditActive: {
			type: Boolean,
			required: true,
		},
		data: {
			type: Object,
		},
		hideModal: Function,
	},
	components: {
		vSelect,
		flatPickr,
	},
	data() {
		return {
			breakItem: {},
			resourceSelected: "",
			resourcesList: [],
			SubmitButtonTitle: "",
			configdateTimePicker: {
				enableTime: true,
				enableSeconds: true,
				noCalendar: true,
				dateFormat: "H:i:S",
			},
		};
	},
	methods: {
		cancel() {
			if (this.isEditActive) {
				this.$emit("closeSidebar");
			} else {
				this.hideModal();
			}
		},
		formatDates(dateString) {
			// 'Tue, 18 Mar 2025 19:35:52 GMT'
			const newDate = new Date(dateString);
			return DateUtils.toDefaultDateTime(newDate, "HH:MM:SS");
		},
		submitForm() {
			this.$vs.loading();
			this.$validator.validateAll().then((result) => {
				if (result) {
					if (this.isEditActive) {
						this.updateData();
					} else {
						this.saveData();
					}
				} else {
					this.$vs.notify({
						color: "warning",
						title: this.$t("MissingFieldTitle"),
						text: this.$t("MissingField"),
					});
					this.$vs.loading.close();
				}
			});
		},
		saveData() {
			let params = {};
			if (this.resourceSelected) {
				params = {
					...this.breakItem,
					resource_id: this.resourceSelected.map((el) => el.value),
				};
			} else {
				params = {...this.breakItem};
			}
			this.$store
				.dispatch("moduleStatus/addStatus", params)
				.then((res) => {
					this.$vs.notify({
						color: "success",
						title: this.$t("Status.Messages.TitleConfirmCreate"),
						text: this.$t("Status.Messages.TextConfirmCreate"),
					});
					this.$vs.loading.close();
					this.hideModal();
				})
				.catch((err) => {
					this.$vs.loading.close();
					console.error(err);
					if (err.data.reason === "init_hour greater than end_hour") {
						this.$vs.notify({
							color: "danger",
							title: "Error",
							text: "La hora inicial no puede ser mayor a la hora final",
						});
					} else {
						this.$vs.notify({
							color: "warning",
							title: this.$t("MissingFieldTitle"),
							text: this.$t("MissingField"),
						});
					}
				});
		},
		updateData() {
			let params = {};
			if (this.resourceSelected) {
				params = {
					...this.breakItem,
					resource_id: this.resourceSelected.map((el) => el.value),
				};
			} else {
				params = {...this.breakItem};
			}
			this.$store
				.dispatch("moduleStatus/updateItem", params)
				.then((res) => {
					this.$vs.notify({
						color: "success",
						title: this.$t("Status.Messages.TitleConfirmUpdate"),
						text: this.$t("Status.Messages.TextConfirmUpdate"),
					});
					this.$emit("closeSidebar");
					this.$vs.loading.close();
				})
				.catch((err) => {
					console.error(err);
					this.$vs.loading.close();
					if (err.data.reason === "init_hour greater than end_hour") {
						this.$vs.notify({
							color: "danger",
							title: "Error",
							text: "La hora inicial no puede ser mayor a la hora final",
						});
					} else {
						this.$vs.notify({
							color: "warning",
							title: this.$t("MissingFieldTitle"),
							text: this.$t("MissingField"),
						});
					}
				});
		},
		checkResources() {
			this.$store.dispatch("moduleStatus/fetchResourceData");
			const resourcesData = this.resources();
			this.resourcesList = resourcesData.map((el) => {
				return {value: el.id, label: el.name};
			});
		},
	},
	computed: {
		title() {
			return this.$t("Status.Title");
		},
		SubmitButtonTitleCreate() {
			return this.$t("Status.Create");
		},
		SubmitButtonTitleEdit() {
			return this.$t("Status.UpdateStatus");
		},
		resources() {
			return this.$store.getters["moduleStatus/getResources"];
		},
		isEditActiveLocal: {
			get() {
				return this.isEditActive;
			},
			set(val) {},
		},
	},
	mounted() {
		this.breakItem = Object.assign({}, this.data);
		this.$store.dispatch("moduleStatus/fetchResourceData");
		const resourcesData = this.resources();
		this.resourcesList = resourcesData.map((el) => {
			return {value: el.id, label: el.name};
		});
	},
	created() {
		if (!moduleStatus.isRegistered) {
			this.$store.registerModule("moduleStatus", moduleStatus);
			moduleStatus.isRegistered = true;
		}
	},
	watch: {
		isEditActive(val) {},
	},
};
</script>
